module.exports = __webpack_public_path__ + "img/icon-clients-purple.3c3e3da3.svg";